<mat-form-field>
  <mat-select
    [value]="selected"
    (selectionChange)="handleChange($event.value)">
    @for (option of options; track option) {
      <mat-option
      [value]="option">{{ option }}</mat-option>
    }
  </mat-select>
</mat-form-field>
@if (selected === 'Location') {
  <emm-search-by-location
  ></emm-search-by-location>
}
@if (selected === 'Location Sets') {
  <emm-location-sets-dropdown
    class="location-sets-dropdown"
  ></emm-location-sets-dropdown>
}
